import { Col, Result, Row, Spin } from "antd";
import { useIntl } from "react-intl";
import { useHealthCheck } from "../../../hooks/useHealthCheck.ts";

export const HealthPage = () => {
  const { formatMessage } = useIntl();
  const { isLoading, data: isSuccess } = useHealthCheck();

  if (isLoading) {
    return (
      <Row justify="center" align="middle">
        <Col>
          <Spin size={"large"} />
        </Col>
      </Row>
    );
  }

  return (
    <Result
      status={isSuccess ? "success" : "error"}
      title={formatMessage({ id: "healthPage.title" })}
      subTitle={formatMessage({
        id: isSuccess ? "healthPage.subTitle.success" : "healthPage.subTitle.error",
      })}
    />
  );
};
